/*
 * @Author: WLL
 * @Date: 2020-04-13 15:06:55
 * @LastEditors: WLL
 * @LastEditTime: 2020-04-20 12:27:39
 * @Description: 路由
 */
import Vue from "vue";
import VueRouter from "vue-router";
import DemoComponents from "sj_components/src/views/DemoComponents";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "home"
  },
  {
    path: "/auth",
    name: "auth",
    component: () => import(/* webpackChunkName: "home" */ "@/views/Auth")
  },
  {
    path: "/no-auth",
    name: "no-auth",
    component: () => import(/* webpackChunkName: "home" */ "@/views/NoAuth"),
    meta: {
      title: "未登录"
    }
  },
  {
    path: "/home",
    name: "home",
    component: () => import(/* webpackChunkName: "home" */ "@/views/Home"),
    meta: {
      title: "金榜首页"
    }
  },
  {
    path: "/organization",
    name: "organization",
    component: () =>
      import(/* webpackChunkName: "organization" */ "@/views/Organization"),
    meta: {
      title: "机构预测排行"
    }
  },
  {
    path: "/analyst",
    name: "analyst",
    component: () =>
      import(/* webpackChunkName: "analyst" */ "@/views/Analyst"),
    meta: {
      title: "分析师预测排行"
    }
  },
  {
    path: "/industry",
    name: "industry",
    component: () =>
      import(/* webpackChunkName: "industry" */ "@/views/Industry"),
    meta: {
      title: "机构关注行业"
    }
  },
  {
    path: "/stock",
    name: "stock",
    component: () => import(/* webpackChunkName: "stock" */ "@/views/Stock"),
    meta: {
      title: "个股盈利预测"
    }
  },
  {
    path: "/reportDetail",
    name: "reportDetail",
    component: () =>
      import(/* webpackChunkName: "reportDetail" */ "@/views/ReportDetail"),
    meta: {
      title: "研报详情"
    }
  }
];

if (process.env.NODE_ENV === "development") {
  routes.push({
    path: "/components",
    name: "components",
    component: () => import("sj_components/src/views/Demo"),
    redirect: `/components/${DemoComponents[0].name}`,
    children: DemoComponents
  });
}
const router = new VueRouter({
  routes
});
router.beforeEach((to, from, next) => {
  if (to.name === "no-auth") {
    next();
    return;
  }
  document.title = to.meta.title;
  if (to.name === "auth") {
    document.title = from.meta.title;
  }
  const query = Object.assign({}, to.query, from.query);
  if (!query.token) {
    if (process.env.NODE_ENV === "development") {
      next();
      return;
    }
    router.push({
      name: "no-auth"
    });
    return;
  }
  if (!to.query.token) {
    if (query.token) {
      to.query.token = query.token;
    }
    if (query.domain) {
      to.query.domain = query.domain;
    }
    if (query.username) {
      to.query.username = query.username;
    }

    if (query.nickname) {
      to.query.nickname = query.nickname;
    }
    if (query.themeType) {
      to.query.themeType = query.themeType;
    }
    router.push({
      path: to.path,
      query: to.query
    });
    return;
  }
  next();
});
export default router;
